import {createContext, useContext, useEffect} from "react";

export type BrandingControl = {
    setSuffix: (s: string) => void;
    resetBranding: () => void;
};

export const BrandingControlContext = createContext<undefined | BrandingControl>(undefined);

export const useBrandingControl = () => {
    const brandingControl = useContext(BrandingControlContext)
    if (!brandingControl) throw new Error("useBranding must be used inside <AppFwApp/>");
    return brandingControl;
}

export function useBrandingTitleSuffix(suffix: string) {
    const {setSuffix, resetBranding} = useBrandingControl()
    useEffect(() => {
        setSuffix(suffix)
        return () => resetBranding()
    }, [])
}